import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

import { ATOMS } from "../../recoil/atom";
import { INetworkVersion } from "../../types/versions";
import { createSnackBarContent } from "../global/useSnackBar";
import { fireDatabase } from "../../config/firebase";
import { needRequestCollections } from "../../constants/access";
import { sortByVersion } from "../../utils/versions";
import useNeedRequestVisibilityHelper from "../data/useNeedRequestVisibilityHelper";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

const collectionRequired = [needRequestCollections.VERSIONS];

const useNetworkVersionsList = () => {
  const { t } = useTranslation(["snackbar"]);

  const popSnackbar = useSetAtom(ATOMS.SNACKBAR);

  const setNetworkVersionsList = useSetAtom(ATOMS.NETWORK_VERSIONS);

  const [unSubscribe, setUnSubscribe] = useState<(() => void) | null>(null);

  const canLoadData = useNeedRequestVisibilityHelper(() => {
    unSubscribe && unSubscribe();
  }, collectionRequired);

  // Versions types list
  useEffect(() => {
    if (canLoadData) {
      const unsub = onSnapshot(
        collection(fireDatabase, "versions", "details", "network_versions"),
        (snap) => {
          const dataNetworkVersions: INetworkVersion[] = [];
          snap.docs.forEach((doc) => {
            const data = doc.data();
            if (data) {
              dataNetworkVersions.push(data as INetworkVersion);
            }
          });
          setNetworkVersionsList(
            dataNetworkVersions.sort(sortByVersion("desc")),
          );
        },
        (err) => {
          console.error(err);
          popSnackbar(
            createSnackBarContent({
              content: t("snackbar:request_network_versions_error"),
              severity: "error",
            }),
          );
          setNetworkVersionsList([]);
        },
      );

      setUnSubscribe(() => unsub);
      return () => unsub();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canLoadData]);

  return null;
};

export default useNetworkVersionsList;
